import React from 'react';
import { SvgSizeClassProps } from '../interfaces';

const SVGFightDraw = ({ size = 332, className }: SvgSizeClassProps) => (
  <svg
    width={size}
    height={size * 0.54}
    viewBox='0 0 332 180'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M49.4612 147.355L56.5271 145.853V88.0628L49.4612 89.5647V82.3409L14.1318 89.8505V162.088L49.4612 154.578V147.355ZM63.593 72.1134V79.3371L70.6589 77.8352V150.073L63.593 151.575V158.798L56.5271 160.3V167.524L0 179.539V78.4068L56.5271 66.3915V73.6153L63.593 72.1134Z'
      fill='#321E68'
    />
    <path
      d='M134.197 86.0011L141.263 84.4992V70.0517L134.197 71.5536V64.3299L98.8673 71.8394V100.734L134.197 93.2249V86.0011ZM148.329 54.1023V61.3261L155.394 59.8242V88.7192L148.329 90.2211V97.4448L141.263 98.9467V106.17L127.131 109.174V116.398L134.197 114.896V122.12L141.263 120.618V127.842L148.329 126.34V133.564L155.394 132.062V146.509L141.263 149.513V142.289L134.197 143.791V136.567L127.131 138.069V130.845L120.065 132.347V125.124L112.999 126.626V119.402L105.933 120.904V113.68L98.8673 115.182V158.524L84.7355 161.528V60.3957L141.263 48.3805V55.6042L148.329 54.1023Z'
      fill='#321E68'
    />
    <path
      d='M183.603 97.1708L225.998 88.1594V66.4881L218.932 67.99V60.7663L211.866 62.2682V55.0444L197.735 58.0482V65.272L190.669 66.7739V73.9976L183.603 75.4995V97.1708ZM233.064 50.5387V57.7625L240.13 56.2606V128.498L225.998 131.502V102.607L183.603 111.618V140.513L169.471 143.517V71.2796L176.537 69.7777V62.5539L183.603 61.052V53.8283L190.669 52.3264V45.1026L197.735 43.6007V36.377L211.866 33.3732V40.5969L218.932 39.095V46.3188L225.998 44.8169V52.0406L233.064 50.5387Z'
      fill='#321E68'
    />
    <path
      d='M310.734 91.8195V12.3583L324.865 9.35449V96.0395L317.799 97.5414V104.765L310.734 106.267V113.491L296.602 116.495V109.271L282.47 112.275V119.498L268.338 122.502V115.278L261.272 116.78V109.557L254.206 111.058V24.3735L268.338 21.3697V100.831L282.47 97.8271V61.7084L296.602 58.7046V94.8233L310.734 91.8195Z'
      fill='#321E68'
    />
    <path
      d='M55.7096 138L62.7754 136.498V78.7083L55.7096 80.2102V72.9864L20.3801 80.4959V152.733L55.7096 145.224V138ZM69.8413 62.7589V69.9826L76.9072 68.4807V140.718L69.8413 142.22V149.444L62.7754 150.946V158.17L6.24832 170.185V69.0523L62.7754 57.037V64.2608L69.8413 62.7589Z'
      fill='#F3933A'
    />
    <path
      d='M140.445 76.6466L147.511 75.1447V60.6972L140.445 62.1991V54.9754L105.116 62.4849V91.3799L140.445 83.8703V76.6466ZM154.577 44.7478V51.9716L161.643 50.4697V79.3646L154.577 80.8665V88.0903L147.511 89.5922V96.8159L133.379 99.8197V107.043L140.445 105.542V112.765L147.511 111.263V118.487L154.577 116.985V124.209L161.643 122.707V137.155L147.511 140.158V132.935L140.445 134.437V127.213L133.379 128.715V121.491L126.313 122.993V115.769L119.247 117.271V110.047L112.181 111.549V104.325L105.116 105.827V149.17L90.9838 152.174V51.0412L147.511 39.026V46.2497L154.577 44.7478Z'
      fill='#F3933A'
    />
    <path
      d='M189.851 87.8163L232.246 78.8049V57.1336L225.181 58.6355V51.4118L218.115 52.9137V45.6899L203.983 48.6937V55.9175L196.917 57.4194V64.6431L189.851 66.145V87.8163ZM239.312 41.1842V48.408L246.378 46.9061V119.144L232.246 122.147V93.2524L189.851 102.264V131.159L175.719 134.163V61.9251L182.785 60.4232V53.1994L189.851 51.6975V44.4738L196.917 42.9719V35.7481L203.983 34.2462V27.0225L218.115 24.0187V31.2424L225.181 29.7405V36.9643L232.246 35.4624V42.6861L239.312 41.1842Z'
      fill='#F3933A'
    />
    <path
      d='M316.982 82.465V3.00379L331.114 -1.34575e-05V86.685L324.048 88.1869V95.4106L316.982 96.9125V104.136L302.85 107.14V99.9163L288.718 102.92V110.144L274.587 113.148V105.924L267.521 107.426V100.202L260.455 101.704V15.019L274.587 12.0152V91.4764L288.718 88.4726V52.3539L302.85 49.3501V85.4688L316.982 82.465Z'
      fill='#F3933A'
    />
  </svg>
);

export default SVGFightDraw;
